import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreditCheckLightDiagComponent } from './credit-check-light-diag/credit-check-light-diag.component';
import { AppState } from '../../../state/app.state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { configurationFeatureSelector, creditCheckSelector, customerDetailsSelector, isReadOnlySelector } from '../../../state/app.selectors';
import { SupplierConfiguration } from '../../../configuration/models/supplier-configuration';
import { CreditCheckStatusLabel } from '../../models/credit-check';
import { getStatusLabel } from './helpers/creditCheckHelper';
import { CreditCheckInput } from './model/creditCheckInput';
import { CustomerDetails } from '../../models/customer-details';
import { CreditCheckInfo } from '../../../state/app.models';

@Component({
  selector: 'app-credit-check-light',
  templateUrl: './credit-check-light.component.html',
  styleUrls: ['./credit-check-light.component.scss'],
})
export class CreditCheckLightComponent implements OnInit, OnDestroy {
  public displayCreditCheckButton: boolean;
  public canPerformCreditCheck: boolean;
  private isReadOnly: boolean;
  private supplierConfig$: Subscription;
  private customerDetails$: Subscription;
  private creditCheck$: Subscription;
  private isReadOnly$: Subscription;
  private supplierConfig: SupplierConfiguration;
  private customerDetails: CustomerDetails;
  private creditCheckInfo: CreditCheckInfo;
  constructor(protected dialog: MatDialog, private readonly store: Store<AppState>) { }

  ngOnDestroy(): void {
    this.supplierConfig$.unsubscribe();
    this.customerDetails$.unsubscribe();
    this.creditCheck$.unsubscribe();
    this.isReadOnly$?.unsubscribe();
  }

  ngOnInit(): void {
    this.canPerformCreditCheck = false;

    this.displayCreditCheckButton = false;
    this.supplierConfig$ = this.store.select(configurationFeatureSelector).subscribe((config) => {
      this.supplierConfig = config.config.supplierConfiguration;
      this.displayCreditCheckButton = config.config.supplierConfiguration.creditCheckEnabled;
    });

    this.customerDetails$ = this.store.select(customerDetailsSelector).subscribe((customerDetails) => {
      this.customerDetails = customerDetails;
      this.checkIfCreditCheckCanBePerfomed();
    });

    this.creditCheck$ = this.store.select(creditCheckSelector).subscribe((cc) => {
      this.creditCheckInfo = cc;
    });

    this.isReadOnly$ = this.store.select(isReadOnlySelector).subscribe((isReadOnly) => {
      this.isReadOnly = isReadOnly;
      this.checkIfCreditCheckCanBePerfomed();
    });
  }

  private checkIfCreditCheckCanBePerfomed(): void {
    this.canPerformCreditCheck = 
        !this.isReadOnly && 
        this.customerDetails?.organisationName?.length > 0 && 
        this.customerDetails?.duns?.length > 0;
  }

  showCreditCheckDiag() {
    const creditCheckInput: CreditCheckInput = {
      duns: this.customerDetails.duns,
      organisationName: this.customerDetails.organisationName,
    };

    this.dialog.open(CreditCheckLightDiagComponent, {
      width: '18%',
      height: '55%',
      data: creditCheckInput,
      disableClose: true
    })
  }

  get statusLabel(): CreditCheckStatusLabel {
    return getStatusLabel(this.creditCheckInfo.status);
  }
}
